import { render } from "./follow_button.vue?vue&type=template&id=6a0717e7"
import script from "./follow_button.js?vue&type=script&lang=js&external"
export * from "./follow_button.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__